export function normalizedExportBaseName(name: string): string {
  return (name.trim() || "Untitled")
    .replace(/[\\/:*?"<>|]+/g, "-")
    .replace(/\s+/g, " ")
    .trim();
}

export function defaultAnimationExportScale(): number {
  return Math.max(1, Math.min(3, window.devicePixelRatio || 1));
}

export function pngScaleSuffix(scale: number): string {
  return scale <= 1 ? "" : `@${scale}x`;
}

export function pngScaleLabel(scale: number): string {
  return scale <= 1 ? "PNG" : `PNG @${scale}x`;
}
